export enum ParticipationType {
	participant = 'participant',
	organizer = 'organizer',
}